
      var _circle, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgDefaultSongApplyIcon = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: 25,
  height: 25,
  viewBox: "0 0 16 16",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
  cx: 8,
  cy: 8,
  r: 7.5,
  fill: "var(--theme-primary, #810ea9)",
  stroke: "var(--theme-primary, #810ea9)"
})), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M4.234 6.965a.763.763 0 0 1 1.132 0L7.2 8.931l3.434-3.68a.763.763 0 0 1 1.132 0 .901.901 0 0 1 0 1.212l-4 4.286a.763.763 0 0 1-1.132 0l-2.4-2.571a.901.901 0 0 1 0-1.213z",
  fill: "var(--theme-light, #f9f3fb)"
})));

      const __svgRaw = "<svg width=\"25\" height=\"25\" viewBox=\"0 0 16 16\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\">\r\n    <circle cx=\"8\" cy=\"8\" r=\"7.5\" fill=\"var(--theme-primary, #810ea9)\" stroke=\"var(--theme-primary, #810ea9)\"/>\r\n    <path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M4.234 6.965a.763.763 0 0 1 1.132 0L7.2 8.931l3.434-3.68a.763.763 0 0 1 1.132 0 .901.901 0 0 1 0 1.212l-4 4.286a.763.763 0 0 1-1.132 0l-2.4-2.571a.901.901 0 0 1 0-1.213z\" fill=\"var(--theme-light, #f9f3fb)\"/>\r\n\r\n</svg>";

      function __resolveCssVarsInSvg(svgMarkup) {
        if (typeof window === 'undefined' || !document?.documentElement) {
          return svgMarkup;
        }

        const htmlEl = document.documentElement;
        const bodyEl = document.body;

        function __readCustomProperty(name) {
          let v = getComputedStyle(htmlEl).getPropertyValue(name).trim();
          if (!v && bodyEl) {
            v = getComputedStyle(bodyEl).getPropertyValue(name).trim();
          }
          return v;
        }

        function __expandVarToken(fullMatch, seen) {
          if (!seen) seen = new Set();
          const m = String(fullMatch)
            .trim()
            .match(/^var\(\s*(--[^),\s]+)(?:\s*,\s*([^)]+))?\s*\)$/i);
          if (!m) return fullMatch;
          const varName = m[1];
          const fallbackRaw = m[2] != null ? String(m[2]).trim() : '';
          if (seen.has(varName)) {
            return fallbackRaw || fullMatch;
          }
          seen.add(varName);
          let specified = __readCustomProperty(varName);
          if (!specified) {
            return fallbackRaw || fullMatch;
          }
          specified = specified.trim();
          if (/^var\s*\(/i.test(specified)) {
            return __expandVarToken(specified, seen) || fallbackRaw || fullMatch;
          }
          return specified || fallbackRaw || fullMatch;
        }

        return svgMarkup.replace(
          /var\(\s*(--[^),\s]+)(?:\s*,\s*([^)]+))?\s*\)/gi,
          (fullMatch) => __expandVarToken(fullMatch, new Set())
        );
      }

      function __getSvg() {
        return __resolveCssVarsInSvg(__svgRaw);
      }

      function __getBg() {
        const resolved =__resolveCssVarsInSvg(__svgRaw);

        const encoded = encodeURIComponent(resolved)
          .replace(/'/g, '%27')
          .replace(/"/g, '%22');
        return "url('data:image/svg+xml;charset=utf-8," + encoded + "')"; }

      export default Object.assign(
        new String(__webpack_public_path__ + "Assets/defaultSongApplyIcon.435036f255f57fe9b2c0ebec9cc4e132.svg"),
        {
          React: SvgDefaultSongApplyIcon,
          svgClassName: undefined,
          svg: __getSvg,
          bg: __getBg
        }
      );
      